import React, { Component, Fragment } from "react";
import "../App.css";
import { connect } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";
import { ActionCreators } from "../actions";
import ButtonAppBar from "./appBar";

class LandingPage extends Component {
  state = {
    open: false,
    vertical: "top",
    horizontal: "center"
  };

  handleClick = state => () => {
    this.setState({ open: true, ...state });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  componentDidMount() {
    this.props.resetMap();
    this.props.gaPageView("/");

    // Detects if device is on iOS
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };
    // Detects if device is in standalone mode
    const isInStandaloneMode = () =>
      "standalone" in window.navigator && window.navigator.standalone;

    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      this.setState({ open: true });
    }
  }
  render() {
    const { vertical, horizontal, open } = this.state;
    const action = (
      <Button onClick={this.handleClose} color="secondary" size="small">
        close
      </Button>
    );
    return (
      <Fragment>
        <div className="text-center">
          <div className=" jumbotron-fluid">
            <ButtonAppBar />
            <img
              src={require("../assets/field.jpg")}
              alt="field"
              width="100%"
              height="100%"
            />
          </div>
          <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
            <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
              <main role="main" className="inner cover">
                <h1 className="cover-heading ">Data Collection Application</h1>
                <p className="lead">
                  The Arkansas Game and Fish Commission's mission is to conserve
                  and enhance Arkansas's fish and wildlife and their habitats
                  while promoting sustainable use, public understanding and
                  support.
                </p>
              </main>
            </div>
          </div>
        </div>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          message={
            <span id="message-id">
              To install this webapp to your iOS Device: tap {" "}
              <img
                src={require("../assets/iosUpload.png")}
                alt="share"
                width="10%"
              height="10%"
              />{" "}
              and Add to homescreen
            </span>
          }
          action={action}
        />
      </Fragment>
    );
  }
}
export default connect(
  null,
  ActionCreators
)(LandingPage);



// WEBPACK FOOTER //
// ./src/components/home.jsx